'use strict';

import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  if ($('body').is('#plans')) {
    $(document).on('submit', '.switch-plan-form', (e) => {
      $('.p-button--switch-plan').addClass('button-loading');
    });

    $(document).on('ajax:success', '.switch-plan-form', function (data, status, xhr) {
      $('.switch-plan-form').hide();
      $('.modal__header').hide();
      $('.modal__header--switched-plan').show();

      // make sure page is reload when user closes the modal
      $('.close-modal').addClass('close-modal--redirect-to-projects');
    });

    $(document).on('ajax:error', '.switch-plan-form', function (event, xhr) {
      $('.p-button--switch-plan').removeClass('button-loading');
      const message = xhr.responseJSON && xhr.responseJSON.error_message;
      alert(message || 'Something went wrong. Please try again or contact support.');
    });

    // reload the page when designer closes the modal
    $(document).on('click', '.close-modal--redirect-to-projects', (e) => {
      const $switchedPlan = $('.modal__header--switched-plan');
      const fromPlan = $switchedPlan.data('from-plan');
      const toPlan = $switchedPlan.data('to-plan');
      window.location.href = `/projects?switched_plan=1&from_plan=${fromPlan}&to_plan=${toPlan}`;

      return false;
    });

    // visible only in mobile view
    $(document).on('click', '.plans-features-dropdown__header', (e) => {
      const dropdown = $(e.target).closest('.plans-features-dropdown');
      dropdown.find('.plans-include-dropdown').slideToggle();
      dropdown.toggleClass('plans-features-dropdown--active');
      return false;
    });
  }

  $(document).on('click', '.accordion-dropdown__dropdown-header', (e) => {
    const $target = $(e.currentTarget);
    if ($target.hasClass('accordion-dropdown__dropdown-header--active')) {
      $('.accordion-dropdown__dropdown-text').slideUp(250);
      $target.removeClass('accordion-dropdown__dropdown-header--active');
      $('.accordion-dropdown__dropdown').removeClass('accordion-dropdown__dropdown--active');
    } else {
      $('.accordion-dropdown__dropdown-text').slideUp(250);
      $('.accordion-dropdown__dropdown-header--active').removeClass(
        'accordion-dropdown__dropdown-header--active'
      );
      $('.accordion-dropdown__dropdown').removeClass('accordion-dropdown__dropdown--active');
      $target
        .addClass('accordion-dropdown__dropdown-header--active')
        .next('.accordion-dropdown__dropdown-text')
        .slideDown(250);
      $target
        .closest('.accordion-dropdown__dropdown')
        .addClass('accordion-dropdown__dropdown--active');
    }
  });

  $(document).ready(function () {
    if ($('.platform-comparison__body').length) {
      $('.platform-comparison__body').jcarousel({ wrap: 'circular' });
      $('.platform-comparison__arrow--prev').jcarouselControl({ target: '-=1' });
      $('.platform-comparison__arrow--next').jcarouselControl({ target: '+=1' });
      $('.platform-comparison__pagination')
        .on('jcarouselpagination:active', 'a', function () {
          $(this).addClass('active');
        })
        .on('jcarouselpagination:inactive', 'a', function () {
          $(this).removeClass('active');
        })
        .jcarouselPagination({
          item(page) {
            return `<a href="#${page}" class="platform-comparison__page"></a>`;
          },
        });
    }
  });

  $(document).ready(function () {
    $('.mobile-testimonials').jcarousel();

    $('.mobile-testimonials__next')
      .on('jcarouselcontrol:active', (e) => {
        $(e.target).css('visibility', 'visible');
      })
      .on('jcarouselcontrol:inactive', (e) => {
        $(e.target).css('visibility', 'hidden');
      })
      .jcarouselControl({
        target: '+=1',
      });

    $('.mobile-testimonials__prev')
      .on('jcarouselcontrol:active', (e) => {
        $(e.target).css('visibility', 'visible');
      })
      .on('jcarouselcontrol:inactive', (e) => {
        $(e.target).css('visibility', 'hidden');
      })
      .jcarouselControl({
        target: '-=1',
      });

    $('.mobile-testimonials__pagination')
      .on('jcarouselpagination:active', 'a', (e) => {
        $(e.target).addClass('active');
      })
      .on('jcarouselpagination:inactive', 'a', (e) => {
        $(e.target).removeClass('active');
      })
      .jcarouselPagination({
        item(page) {
          return `<a href="#${page}" class="mobile-testimonials__page board-examples__page--${page}"></a>`;
        },
      });

    // move testimonials items by swiping
    const mobileTestimonials = document.getElementsByClassName('mobile-testimonials')[0];
    if (mobileTestimonials !== undefined) {
      let touchstartX;
      mobileTestimonials.addEventListener(
        'touchstart',
        function (event) {
          touchstartX = event.changedTouches[0].screenX;
        },
        false
      );
      mobileTestimonials.addEventListener(
        'touchend',
        function (event) {
          const touchendX = event.changedTouches[0].screenX;
          if (touchendX < touchstartX) {
            $('.mobile-testimonials__next').click();
          }

          if (touchendX > touchstartX) {
            $('.mobile-testimonials__prev').click();
          }
        },
        false
      );
    }

    // calculate daily price for plan breakdowns
    const prices = document.querySelectorAll('.plans-include__plan-name');
    prices.forEach((element) => {
      const dailyPrice = ($(element).find('.plan-price__price').text() / 30).toFixed(2);
      $(element).find('.plans-include__daily-amount').text(dailyPrice);
    });

    // now, when prices are calculated for desctop view - copy element and move it to mobile dropdown
    const edesingPill = $('.plans-include__plan-name--edesign').find('.plan-pill').clone();
    edesingPill.addClass('plan-pill--dropdown');
    $('.plans-features-dropdown--e-design').find('.plans-include-dropdown').prepend(edesingPill);
    const fullservicePill = $('.plans-include__plan-name--fullservice').find('.plan-pill').clone();
    fullservicePill.addClass('plan-pill--dropdown');
    $('.plans-features-dropdown--fullservice')
      .find('.plans-include-dropdown')
      .prepend(fullservicePill);
  });
});
